<div class="bn-color-picker">
  <div class="row align-items-center">
    <span
      class="d-flex align-items-center col-4"
      [ngClass]="{ 'order-2 col-6': colors.length > 2 }">
      @if (label) {
        <label class="bn-color-picker__label">{{ label }}</label>
      }
    </span>
    @if (showColors) {
      <span
        class="bn-color-picker__color-pallete col-3"
        [ngClass]="{ 'order-1 col-12 mb-4': colors.length > 2 }">
        <bn-web-ui-color-picker-colors
          [colors]="colors"
          [selectedColor]="colorControl.value"
          (onColorClick)="handleColorClick($event)" />
      </span>
    }
    <label
      class="col-5"
      [ngClass]="{ 'col-6 order-3': colors.length > 2 }">
      <div class="bn-color-picker__input--wrap">
        <div
          class="bn-color-picker__input__color"
          [style.backgroundColor]="colorControl.value"></div>
        <span>
          <input
            class="bn-color-picker__input"
            cpAlphaChannel="disabled"
            cpOutputFormat="hex"
            cpPosition="bottom"
            cpWidth="240px"
            spellcheck="false"
            [colorPicker]="colorControl.value"
            [cpEyeDropper]="true"
            [formControl]="colorControl"
            [readonly]="readonly"
            [style.color]="colorControl.value"
            (colorPickerChange)="colorControl.setValue($event)" />
        </span>
      </div>

      @if (!colorControl.valid && colorControl.touched) {
        <bn-web-ui-formcontrol-errors
          inputDisplayName="Color"
          [control]="colorControl"
          [customError]="errorMessage" />
      }
    </label>
  </div>
</div>
